import { Component, Output, Input } from "@angular/core";
import * as _ from "lodash";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { PermissionsService } from "src/app/shared/services/permissions.service";
import { PermissionsEnum } from "src/app/shared/Models/enums/PermissionsEnum";

export interface DocumentGeneralRemarkModalSaveResponse {
  remarks: string;
  callback: () => void;
}

@Component({
  selector: "app-document-general-remark-modal",
  templateUrl: "./document-general-remark-modal.component.html",
  styleUrls: ["./document-general-remark-modal.component.scss"],
})
export class DocumentGeneralRemarkModalComponent {
  @Output()
  save: Subject<DocumentGeneralRemarkModalSaveResponse> = new Subject<DocumentGeneralRemarkModalSaveResponse>();

  @Input()
  remarks: string;

  canWrite: boolean;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private permissionsService: PermissionsService
  ) {
    this.canWrite = this.permissionsService.allowed(
      PermissionsEnum.EditDocumentList
    );
  }

  onClose() {
    this.activeModal.dismiss("Cross click");
  }

  get canSave() {
    return this.canWrite && !!this.remarks;
  }

  onSave() {
    this.save.next({ remarks: this.remarks, callback: this.activeModal.close });
  }
}
